import get from 'lodash/get'
import { normalize } from 'normalizr'
import { arrayOfPrices } from '../schemas/priceSchema'

export default originalData => {
    let result = normalize(get(originalData, 'prices', []), arrayOfPrices)
    result.currency = originalData.currency
    return result
}



// WEBPACK FOOTER //
// ./adapters/parsers/pricesParser.js